import { PaginazioneDTO } from "./paginazioneDTO";
import { RicercaSoggettoDTO } from "./anagrafe/ricerca-soggettoDTO";
import { RicercaRecapitoDTO } from "./anagrafe/ricerca-recapitoDTO";

export class FiltroRicercaAnagrafeDTO {
  ricercaSoggetto: RicercaSoggettoDTO;
  ricercaRecapito: RicercaRecapitoDTO;
  tipiRecapito: string;
  paginazione: PaginazioneDTO;
}
